export default "__VITE_ASSET__6cRrpokg__"